import { useNavigate } from 'react-router-dom';
import { Settings } from 'lucide-react';

/**
 * 登録マスタの該当タブへジャンプするボタン。
 * 各画面の右上に置き、その画面に関係する選択肢・判定基準のマスタへ直行できるようにする。
 * （例: 休息時間→休憩管理、ヒヤリハット→カテゴリマスタ）
 */
export default function MasterLinkButton({ tab, title }: { tab: string; title?: string }) {
  const navigate = useNavigate();
  return (
    <button className="btn-o" onClick={() => navigate(`/master/activities?tab=${tab}`)}
      title={title ?? 'この画面に関係する登録マスタを開きます'}>
      <Settings size={13} style={{ display: 'inline', verticalAlign: 'middle', marginRight: 4 }} />
      マスタ管理
    </button>
  );
}
